import { render, staticRenderFns } from "./FraudCaseDetails.vue?vue&type=template&id=9a82a72c&scoped=true&"
import script from "./FraudCaseDetails.vue?vue&type=script&lang=js&"
export * from "./FraudCaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./FraudCaseDetails.vue?vue&type=style&index=0&id=9a82a72c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a82a72c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a82a72c')) {
      api.createRecord('9a82a72c', component.options)
    } else {
      api.reload('9a82a72c', component.options)
    }
    module.hot.accept("./FraudCaseDetails.vue?vue&type=template&id=9a82a72c&scoped=true&", function () {
      api.rerender('9a82a72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/FraudCaseDetails.vue"
export default component.exports